import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  EventEmitter,
  ViewChild,
  Input,
} from "@angular/core";

import { ModalDirective } from "ngx-bootstrap/modal";

import { Subscription } from "rxjs";

import { CompanyEntityComponent } from "./../company-entity/company-entity.component";

import {
  AuthorizationService,
  ToastrService,
  MinesiteService,
  ModelService,
  EquipmentService,
  PoweredByService,
  ClassificationService,
  Model,
  Classification,
  PoweredBy,
  Equipment,
} from "./../../../../shared/index";

@Component({
  selector: "minesite-filter",
  templateUrl: "./minesite-filter.html",
  standalone: false,
})
export class MinesiteFilterComponent implements OnInit, OnDestroy {
  @ViewChild("minesiteFilter") minesiteFilter: ModalDirective;
  @Input("live") live = true;
  private subscriptions: Subscription[] = [];

  public equipment: Equipment[] = [];
  public models: Model[] = [];
  public poweredBys: PoweredBy[] = [];
  public classifications: Classification[] = [];

  public selectedEquipment: number[] = [];
  public selectedModels: number[] = [];
  public selectedPoweredBys: number[] = [];
  public selectedClassifications: number[] = [];

  public filterApplied = false;
  public activeMinesites = true;
  public inActiveMinesites = true;
  public name = "";

  constructor(
    private _ngZone: NgZone,
    private _equipmenService: EquipmentService,
    private _minesiteService: MinesiteService,
    private _modelService: ModelService,
    private _poweredByService: PoweredByService,
    private _classificationService: ClassificationService,
    private _toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this._equipmenService.equipmentChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.equipment = info;
        });
      })
    );

    this.subscriptions.push(
      this._modelService.modelChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.models = info;
        });
      })
    );

    this.subscriptions.push(
      this._poweredByService.poweredByChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.poweredBys = info;
        });
      })
    );

    this.subscriptions.push(
      this._classificationService.classificationChange.subscribe(
        (info: any) => {
          this._ngZone.run(() => {
            this.classifications = info;
          });
        }
      )
    );

    this._equipmenService.getEquipment(this.live);
    if (this.live) {
      this._modelService.getModelsConstraint();
      this._poweredByService.getPoweredBys();
      this._classificationService.getClassifications();
    } else {
      this._modelService.getModelsConstraintStaged();
      this._poweredByService.getPoweredBysStaged();
      this._classificationService.getClassificationsStaged();
    }

    //this.equipment = this._equipmenService.equipment.Data;
    //this.models = this._modelService.models.Data;
    //this.poweredBys = this._poweredByService.poweredBys.Data;
    //this.classifications = this._classificationService.classifications.Data;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  public showFilters(): void {
    this.minesiteFilter.show();
  }

  public applyFilter(): void {
    if (
      this.name != "" ||
      this.activeMinesites == false ||
      this.inActiveMinesites == false ||
      this.selectedModels.length > 0 ||
      this.selectedEquipment.length > 0 ||
      this.selectedPoweredBys.length > 0 ||
      this.selectedClassifications.length > 0
    ) {
      this.filterApplied = true;
    } else {
      this.filterApplied = false;
    }
    this._minesiteService.applyFilter(
      this.name,
      this.activeMinesites,
      this.inActiveMinesites,
      this.live,
      this.selectedModels,
      this.selectedEquipment,
      this.selectedPoweredBys,
      this.selectedClassifications
    );
    this.minesiteFilter.hide();
  }

  public clearFilter(): void {
    this.name = "";
    this.activeMinesites = true;
    this.inActiveMinesites = true;
    this.selectedModels = [];
    this.selectedEquipment = [];
    this.selectedPoweredBys = [];
    this.selectedClassifications = [];
    this.filterApplied = false;
  }

  public close(): void {
    this.minesiteFilter.hide();
  }
}
